import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { isIncentivesCorporate, isIncentivesSalesperson } from 'helpers/permissions';
import { useAppSelector } from 'store/hook';

const Incentives = () => {
  const navigate = useNavigate();
  const { currentUser } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (!(isIncentivesCorporate(currentUser) || isIncentivesSalesperson(currentUser))) {
      navigate(`/`);
    }
  }, []);
  return <Outlet />;
};

export default Incentives;
